<template>
    <div>
        <h1 style="margin:0px 0px 10px; color:#0056A8">Mis Cursos</h1>
        <el-tabs v-model="activeName" >
            <el-tab-pane label="Todos" name="first">
              <all-courses></all-courses>
              </el-tab-pane>
            <el-tab-pane label="En Progreso" name="second">
              <in-progress></in-progress>
              </el-tab-pane>
            <el-tab-pane label="Terminados" name="third">
              <finished></finished>
              </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import allCourses from '@/components/courses/myCourses/allCourses'
import inProgress from '@/components/courses/myCourses/inProgress'
import finished from '@/components/courses/myCourses/finished'
export default {
  components: { allCourses, inProgress, finished },
    data() {
      return {
        activeName: 'first',
      };
    },
    methods: {
      
    }
}
</script>

<style>
  #img-courses {
    width: 200px;
    height: 133px;
    border-radius: 8px;
    box-shadow: 0px 2px 10px rgba(162, 166, 163, 0.25);
  }

  #course-container{
    background-color: #F4F4F4;
    border-radius: 8px;
    margin: 0px 0px 0px 0px;
    height: 132px;
    padding: 5px 20px;
    box-shadow: 0px 2px 10px rgba(162, 166, 163, 0.25);
  }

  #myCourse-name {
    margin: 0;
    color: #0056A8;
    font-size: 20px;
  }

  #program-link {
    margin-bottom: 10px;
    font-size: 14px;
  }

  #btn-continue {
    position: absolute;
    bottom:0px;
    right:20px;
  }

  #score {
        color: #0056A8;
        margin: 5px 0px;
  }

  @media (max-width:767px){
    #img-courses {
      width: 100%;
      height: 133px;
      border-radius: 8px;
      box-shadow: 0px 2px 10px rgba(162, 166, 163, 0.25);
      
    }

    #course-container{
      background-color: #F4F4F4;
      border-radius: 8px;
      margin: -5px 0px 20px 0px;
      height: 100%;
      padding: 5px 20px;
      box-shadow: 0px 2px 10px rgba(162, 166, 163, 0.25);
    }

    #btn-continue {
      bottom: 0px;
      right: 0px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/courses/myCourses/myCourses.vue